module.exports = __webpack_public_path__ + "static/media/16-13.2dc2ea80.mp3";